import React from "react";
import Svg, { Path, Circle } from "react-native-svg";

const SuccessIcon = ({ height = "80", width = "80", ...props }) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 80 80"
      fill="none"
      {...props}
    >
      <Circle opacity="0.1" cx="40" cy="40" r="40" fill="#00AB59" />
      <Circle opacity="0.5" cx="40" cy="40" r="32" fill="#00AB59" />
      <Circle cx="40" cy="40" r="24" fill="#00AB59" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.7231 29.53C54.6458 30.4816 54.6224 32.001 53.6709 32.9237L37.1708 48.9237C36.2399 49.8265 34.7603 49.8265 33.8293 48.9237L26.3293 41.651C25.3778 40.7283 25.3544 39.2089 26.2771 38.2573C27.1999 37.3057 28.7193 37.2824 29.6708 38.2051L35.5001 43.8577L50.3293 29.4778C51.2809 28.5551 52.8003 28.5785 53.7231 29.53Z"
        fill="white"
      />
    </Svg>
  );
};

export default SuccessIcon;
